import { i18n, i18nExists } from 'src/i18n';
import authService from 'src/modules/auth/authService';
import AuthCurrentTenant from 'src/modules/auth/authCurrentTenant';
import { getHistory } from 'src/modules/store';
import Message from 'src/view/shared/message';
import {
  rememberDisabledReason,
  selectErrorReason,
  USER_DISABLED_REASON,
} from 'src/modules/auth/authDisabledReason';

const DEFAULT_ERROR_MESSAGE = i18n(
  'errors.defaultErrorMessage',
);

function selectErrorKeyOrMessage(error) {
  if (error && error.response && error.response.data) {
    const data = error.response.data;

    if (data.error && data.error.message) {
      return data.error.message;
    }

    return String(data);
  }

  return error.message || DEFAULT_ERROR_MESSAGE;
}

function selectErrorMessage(error) {
  const key = selectErrorKeyOrMessage(error);

  if (i18nExists(key)) {
    return i18n(key);
  }

  return key;
}

function selectErrorCode(error) {
  if (error && error.response && error.response.status) {
    return error.response.status;
  }

  return 500;
}

export default class Errors {
  static handle(error) {
    if (process.env.NODE_ENV !== 'test') {
      console.error(selectErrorMessage(error));
      console.error(error);
    }

    if (
      selectErrorReason(error) === USER_DISABLED_REASON
    ) {
      // Revalidate memberships before discarding a session that may still
      // have access to another tenant. Initialization handles full lockout.
      rememberDisabledReason();
      AuthCurrentTenant.clear();
      window.location.reload();
      return;
    }

    if (selectErrorCode(error) === 401) {
      authService.signout();
      window.location.reload();
      return;
    }

    if (selectErrorCode(error) === 403) {
      getHistory().push('/403');
      return;
    }

    if ([400, 429].includes(selectErrorCode(error))) {
      Message.error(selectErrorMessage(error));
      return;
    }

    Message.error(selectErrorMessage(error));
  }

  static errorCode(error) {
    return selectErrorCode(error);
  }

  static selectMessage(error) {
    return selectErrorMessage(error);
  }

  static showMessage(error) {
    Message.error(selectErrorMessage(error));
  }
}
